<template>
  <div class="mbars">
    <h4 class="mbars__h">262 dead. By nationality.</h4>
    <p class="mbars__sub">The post-war Italo-Belgian treaty had sent Italian workers north as miners. Their names dominate the list.</p>
    <div class="mbars__row" v-for="c in marcinelle" :key="c.country">
      <span class="mbars__country">{{ c.country }}</span>
      <div class="mbars__track">
        <div
          class="mbars__bar"
          :style="{ width: `${(c.count / 136) * 100}%`, background: c.country === 'Italy' ? 'var(--accent)' : 'var(--granite)' }"
        ></div>
      </div>
      <span class="mbars__num">{{ c.count }}</span>
    </div>
    <div class="mbars__foot">
      <strong>262</strong> dead of 274 underground. Twelve survived.
    </div>
  </div>
</template>

<script setup lang="ts">
import { MARCINELLE } from '../../data/stroobant';
const marcinelle = MARCINELLE;
</script>

<style scoped>
.mbars {
  padding: 1.4rem 1.6rem;
  background: rgba(27, 27, 31, 0.04);
  border-left: 4px solid var(--accent);
  border-radius: 0 4px 4px 0;
  display: grid;
  gap: 0.4rem;
}
.mbars__h {
  font-family: var(--font-body);
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0 0 0.3rem;
  color: var(--slate);
  line-height: 1.2;
}
.mbars__sub {
  font-size: 0.94rem;
  color: var(--granite);
  margin: 0 0 0.8rem;
}
.mbars__row {
  display: grid;
  grid-template-columns: 96px 1fr 48px;
  gap: 0.8rem;
  align-items: center;
  font-size: 0.94rem;
}
.mbars__country { color: var(--slate); }
.mbars__track { height: 12px; background: rgba(27,27,31,0.06); border-radius: 2px; }
.mbars__bar { height: 100%; border-radius: 2px; }
.mbars__num {
  font-family: var(--font-body);
  font-weight: 600;
  text-align: right;
  color: var(--slate);
}
.mbars__foot {
  margin-top: 0.6rem;
  font-size: 0.96rem;
  color: var(--slate-soft);
}
.mbars__foot strong { color: var(--accent); font-weight: 700; font-size: 1.2em; font-family: var(--font-body); }
</style>
